

import React, { useState, useEffect } from 'react';
import {Box,Container,Grid,Card,CardContent,CardActions,Typography,Button,TextField,Select,MenuItem,FormControl,InputLabel,Checkbox,FormControlLabel,
  Chip,Alert,Snackbar,Dialog,DialogTitle,DialogContent,DialogActions,Paper,Divider,InputAdornment,Table,TableBody,TableCell,TableContainer,TableHead,
  TableRow,IconButton,Tooltip,ToggleButtonGroup,ToggleButton
} from '@mui/material';
import {CheckCircle,Package,Users,IndianRupee,Plus,Edit,Trash2,Search,LayoutGrid,List as ListIcon
} from 'lucide-react';
import {fetchUserFromRedis} from "../AuthonticationPages/Register"
import { apiRequest } from '../../fetchSetup';

// const API_BASE_URL = 'http://localhost:5001/api/flask';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SubscriptionManagement = () => {
  // const [currentUserId] = useState('admin-001');
  const [subscriptions, setSubscriptions] = useState([]);
  const [stats, setStats] = useState(null);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [viewMode, setViewMode] = useState('cards');
  const [searchQuery, setSearchQuery] = useState('');
  const [userRole, setUserRole] = useState('admin');
  const [currentUserId, setCurrentUserId] = useState('');


  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const loadUser = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
  
    try {
      const data = await fetchUserFromRedis();
  
      console.log("Redis User Data:", data); // ✅ debug
  
      if (data) {
        setUser(data);
  
        // ✅ this is where userId comes from
        const uid = data.user_id || data.id;
        console.log("userrrrrriddddd::::",uid)
  
        // store it into session
        sessionStorage.setItem("userId", uid);
  
        setCurrentUserId(uid);
  
        if (data.role) {
          sessionStorage.setItem("userrole", data.role);
        }
      }
  
    } catch (error) {
      console.error("Failed to load user:", error);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    loadUser();
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price_per_month: '',
    validity_days: '',
    status: 'active',
    features: {
      diagnostic_discount_percent: 0,
      medicine_discount_percent: 0,
      free_pickup: false,
      priority_support: false,
      home_sample_collection: false,
      health_checkup_discount: 0
    }
  });
  
  const [notification, setNotification] = useState(null);

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
  };
  useEffect(() => {
    if (currentUserId) {
      fetchAllSubscriptions();
      fetchStats();
    }
  }, [currentUserId]);
  
  const fetchAllSubscriptions = async () => {
    try {
      // const userId = currentUserId || sessionStorage.getItem("userId");
      const userId =  sessionStorage.getItem("userId");
      if (!userId) {
        console.error("No userId found in session");
        return;
      }
  
      const response = await apiRequest(`${API_BASE_URL}/subscriptions/all`, {
        headers: { 'X-User-Id': userId }
      });
  
      const data = await response.json();
  
      if (data.success) {
        setSubscriptions(data.subscriptions);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions", error);
    }
  };
  
  const fetchStats = async () => {
    try {
      const userId = currentUserId || sessionStorage.getItem("userId");
  
      if (!userId) {
        console.error("No userId found in session");
        return;
      }
  
      const response = await apiRequest(`${API_BASE_URL}/subscriptions/stats`, {
        headers: { 'X-User-Id': userId }
      });
  
      const data = await response.json();
  
      if (data.success) {
        setStats(data.stats);
      }
    } catch (error) {
      console.error("Failed to fetch stats", error);
    }
  };
  

  const handleSubmit = async () => {
    const endpoint = editingPlan 
      ? `${API_BASE_URL}/subscriptions/update/${editingPlan.subscription_id}`
      : `${API_BASE_URL}/subscriptions/create`;
    
    try {
      const response = await apiRequest(endpoint, {
        method: editingPlan ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-Id': currentUserId
        },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      if (data.success) {
        showNotification(editingPlan ? 'Plan updated successfully!' : 'Plan created successfully!');
        setShowCreateDialog(false);
        setEditingPlan(null);
        resetForm();
        fetchAllSubscriptions();
        fetchStats();
      } else {
        showNotification(data.error || 'Operation failed', 'error');
      }
    } catch (error) {
      showNotification('Error occurred', 'error');
    }
  };

  const deleteSubscription = async (subscriptionId) => {
    if (!window.confirm('Are you sure you want to delete this plan?')) return;
    
    try {
      const response = await apiRequest(`${API_BASE_URL}/subscriptions/delete/${subscriptionId}`, {
        method: 'DELETE',
        headers: { 'X-User-Id': currentUserId }
      });
      const data = await response.json();
      if (data.success) {
        showNotification('Plan deleted successfully!');
        fetchAllSubscriptions();
        fetchStats();
      } else {
        showNotification(data.error || 'Failed to delete plan', 'error');
      }
    } catch (error) {
      showNotification('Error deleting plan', 'error');
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      price_per_month: '',
      validity_days: '',
      status: 'active',
      features: {
        diagnostic_discount_percent: 0,
        medicine_discount_percent: 0,
        free_pickup: false,
        priority_support: false,
        home_sample_collection: false,
        health_checkup_discount: 0
      }
    });
  };

  const startEdit = (plan) => {
    setEditingPlan(plan);
    setFormData({
      name: plan.name,
      description: plan.description,
      price_per_month: plan.price_per_month,
      validity_days: plan.validity_days,
      status: plan.status,
      features: { ...plan.features }
    });
    setShowCreateDialog(true);
  };

  const openCreateDialog = () => {
    setEditingPlan(null);
    resetForm();
    setShowCreateDialog(true);
  };

  useEffect(() => {
    fetchAllSubscriptions();
    fetchStats();
  }, []);

  const filteredSubscriptions = subscriptions.filter(sub =>
    sub.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    sub.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const StatCard = ({ title, value, icon: Icon, gradient, subtitle }) => (
    <Card sx={{ 
      background: gradient,
      color: 'white',
      height: '100%',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 6
      }
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ opacity: 0.9, mb: 1, fontWeight: 500 }}>
              {title}
            </Typography>
            <Typography variant="h3" fontWeight="bold" sx={{ mb: 0.5 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box sx={{ 
            bgcolor: 'rgba(255,255,255,0.2)', 
            borderRadius: 2, 
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Icon size={32} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', py: 4,marginLeft:"300px" }}>
      <Container maxWidth="xl">
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h3" fontWeight="bold" sx={{ mb: 1, color: '#1e293b' }}>
            Subscription Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage subscription plans and monitor performance
          </Typography>
        </Box>

        {/* Stats Dashboard */}
        {stats && (
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} lg={3}>
              <StatCard
                title="Total Plans"
                value={stats.total_subscription_plans}
                icon={Package}
                gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <StatCard
                title="Active Plans"
                value={stats.active_subscription_plans}
                icon={CheckCircle}
                gradient="linear-gradient(135deg, #10b981 0%, #059669 100%)"
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <StatCard
                title="Active Subscribers"
                value={stats.active_user_subscriptions}
                icon={Users}
                gradient="linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                subtitle={`${stats.total_purchases} total purchases`}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <StatCard
                title="Total Revenue"
                value={`₹${stats.total_revenue.toLocaleString()}`}
                // icon={DollarSign}
                icon={IndianRupee}
                gradient="linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
              />
            </Grid>
          </Grid>
        )}

        {/* Action Bar */}
        <Paper sx={{ p: 2.5, mb: 3, display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>
          <TextField
            placeholder="Search plans..."
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search size={20} />
                </InputAdornment>
              )
            }}
            sx={{ flexGrow: 1, minWidth: 250, maxWidth: 400 }}
          />
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, newMode) => newMode && setViewMode(newMode)}
              size="small"
            >
              <ToggleButton value="cards">
                <LayoutGrid size={20} />
              </ToggleButton>
              <ToggleButton value="table">
                <ListIcon size={20} />
              </ToggleButton>
            </ToggleButtonGroup>
            <Button
              variant="contained"
              startIcon={<Plus size={20} />}
              onClick={openCreateDialog}
              sx={{ 
                bgcolor: '#3b82f6',
                '&:hover': { bgcolor: '#2563eb' },
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Create New Plan
            </Button>
          </Box>
        </Paper>

        {/* Subscription Plans Display - Cards View */}
        {viewMode === 'cards' && (
          <Grid container spacing={3}>
            {filteredSubscriptions.map((plan) => (
              <Grid item xs={12} md={6} lg={4} key={plan.subscription_id}>
                <Card sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: 6,
                    transform: 'translateY(-4px)'
                  }
                }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                      <Typography variant="h5" fontWeight="bold" sx={{ color: '#1e293b' }}>
                        {plan.name}
                      </Typography>
                      <Chip
                        label={plan.status}
                        size="small"
                        color={plan.status === 'active' ? 'success' : 'default'}
                        sx={{ fontWeight: 600 }}
                      />
                    </Box>

                    <Typography color="text.secondary" sx={{ mb: 2, minHeight: 48 }}>
                      {plan.description}
                    </Typography>

                    <Box sx={{ bgcolor: '#f1f5f9', borderRadius: 2, p: 2, mb: 2 }}>
                      <Typography variant="h4" fontWeight="bold" color="primary">
                        ₹{plan.price_per_month}
                        <Typography component="span" variant="body2" color="text.secondary">
                          /month
                        </Typography>
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {plan.validity_days} days validity
                      </Typography>
                    </Box>

                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                          <Typography variant="h6" fontWeight="bold" color="primary">
                            {plan.total_subscribers || 0}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Subscribers
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                          <Typography variant="caption" color="text.secondary" display="block">
                            Created
                          </Typography>
                          <Typography variant="body2" fontWeight="600">
                            {new Date(plan.created_at).toLocaleDateString('en-IN', { 
                              day: '2-digit', 
                              month: 'short' 
                            })}
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 1, color: '#1e293b' }}>
                    Benefits & Discounts for Services
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                      {plan.features.diagnostic_discount_percent > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">
                            {plan.features.diagnostic_discount_percent}% Diagnostic Discount
                          </Typography>
                        </Box>
                      )}
                      {plan.features.medicine_discount_percent > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">
                            {plan.features.medicine_discount_percent}% Medicine Discount
                          </Typography>
                        </Box>
                      )}
                      {plan.features.health_checkup_discount > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">
                            {plan.features.health_checkup_discount}% Health Checkup Discount
                          </Typography>
                        </Box>
                      )}
                      {plan.features.free_pickup && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">Free Pickup Service</Typography>
                        </Box>
                      )}
                      {plan.features.priority_support && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">Priority Support</Typography>
                        </Box>
                      )}
                      {plan.features.home_sample_collection && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircle size={16} color="#10b981" />
                          <Typography variant="body2">Home Sample Collection</Typography>
                        </Box>
                      )}
                    </Box>
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0, gap: 1 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Edit size={16} />}
                      onClick={() => startEdit(plan)}
                      sx={{ textTransform: 'none' }}
                    >
                      Edit
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="error"
                      startIcon={<Trash2 size={16} />}
                      onClick={() => deleteSubscription(plan.subscription_id)}
                      sx={{ textTransform: 'none' }}
                    >
                      Delete
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Plans Display - Table View */}
        {viewMode === 'table' && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: '#f8fafc' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Plan Name</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Price</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Validity</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Subscribers</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Created</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredSubscriptions.map((plan) => (
                  <TableRow key={plan.subscription_id} hover>
                    <TableCell>
                      <Typography fontWeight="600">{plan.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {plan.description}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold" color="primary">
                        ₹{plan.price_per_month}
                      </Typography>
                    </TableCell>
                    <TableCell>{plan.validity_days} days</TableCell>
                    <TableCell>
                      <Chip 
                        label={plan.total_subscribers || 0} 
                        size="small" 
                        color="primary"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={plan.status}
                        size="small"
                        color={plan.status === 'active' ? 'success' : 'default'}
                      />
                    </TableCell>
                    <TableCell>
                      {new Date(plan.created_at).toLocaleDateString('en-IN')}
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Edit">
                        <IconButton size="small" onClick={() => startEdit(plan)}>
                          <Edit size={18} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={() => deleteSubscription(plan.subscription_id)}
                        >
                          <Trash2 size={18} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Empty State */}
        {filteredSubscriptions.length === 0 && (
          <Paper sx={{ p: 8, textAlign: 'center' }}>
            <Package size={64} style={{ opacity: 0.3, margin: '0 auto 16px' }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No subscription plans found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {searchQuery ? 'Try adjusting your search' : 'Create your first plan to get started'}
            </Typography>
          </Paper>
        )}

        {/* Create/Edit Dialog */}
        <Dialog 
          open={showCreateDialog} 
          onClose={() => {
            setShowCreateDialog(false);
            setEditingPlan(null);
            resetForm();
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Typography variant="h5" fontWeight="bold">
              {editingPlan ? 'Edit Subscription Plan' : 'Create New Subscription Plan'}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2.5} sx={{ mt: 0.5 }}>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="Plan Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth required>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={formData.status}
                    label="Status"
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  multiline
                  rows={3}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Price per Month"
                  type="number"
                  value={formData.price_per_month}
                  onChange={(e) => setFormData({ ...formData, price_per_month: e.target.value })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>
                  }}
                  inputProps={{ min: 0, step: 0.01 }}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Validity (Days)"
                  type="number"
                  value={formData.validity_days}
                  onChange={(e) => setFormData({ ...formData, validity_days: e.target.value })}
                  inputProps={{ min: 1 }}
                  required
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" fontWeight="600" sx={{ mb: 2 }}>
              Features & Benefits
            </Typography>
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Diagnostic Discount (%)"
                  type="number"
                  value={formData.features.diagnostic_discount_percent}
                  onChange={(e) => setFormData({
                    ...formData,
                    features: { ...formData.features, diagnostic_discount_percent: Number(e.target.value) }
                  })}
                  inputProps={{ min: 0, max: 100 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Medicine Discount (%)"
                  type="number"
                  value={formData.features.medicine_discount_percent}
                  onChange={(e) => setFormData({
                    ...formData,
                    features: { ...formData.features, medicine_discount_percent: Number(e.target.value) }
                  })}
                  inputProps={{ min: 0, max: 100 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Health Checkup Discount (%)"
                  type="number"
                  value={formData.features.health_checkup_discount}
                  onChange={(e) => setFormData({
                    ...formData,
                    features: { ...formData.features, health_checkup_discount: Number(e.target.value) }
                  })}
                  inputProps={{ min: 0, max: 100 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 1.5 }}>
                    Additional Features
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.features.free_pickup}
                            onChange={(e) => setFormData({
                              ...formData,
                              features: { ...formData.features, free_pickup: e.target.checked }
                            })}
                          />
                        }
                        label="Free Pickup Service"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.features.priority_support}
                            onChange={(e) => setFormData({
                              ...formData,
                              features: { ...formData.features, priority_support: e.target.checked }
                            })}
                          />
                        }
                        label="Priority Support"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.features.home_sample_collection}
                            onChange={(e) => setFormData({
                              ...formData,
                              features: { ...formData.features, home_sample_collection: e.target.checked }
                            })}
                          />
                        }
                        label="Home Sample Collection"
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
              onClick={() => {
                setShowCreateDialog(false);
                setEditingPlan(null);
                resetForm();
              }}
              variant="outlined"
              sx={{ textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSubmit}
              variant="contained"
              sx={{ 
                bgcolor: '#3b82f6',
                '&:hover': { bgcolor: '#2563eb' },
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              {editingPlan ? 'Update Plan' : 'Create Plan'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Notification Snackbar */}
        <Snackbar
          open={!!notification}
          autoHideDuration={4000}
          onClose={() => setNotification(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          {notification && (
            <Alert
              onClose={() => setNotification(null)}
              severity={notification.type}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {notification.message}
            </Alert>
          )}
        </Snackbar>
      </Container>
    </Box>
  );
};

export default SubscriptionManagement;


